<template>
  <div>
    <y-periodselector
      @period="periodselected"
      :iscierre="true"
      :period="period"
    ></y-periodselector>
    <table class="table is-fullwidth">
      <thead>
        <tr>
          <th>Documento</th>
          <th>Status</th>
          <th>Mensaje</th>
          <th>Detalle</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(fra, index) in fras" :key="index">
          <td>
            <strong>{{ fra.comprobanteid.prefijo }}{{ fra.documento }}</strong>
            <small>{{
              fra.idnit ? fra.idnit.nombre : fra.comprobanteid.titulo
            }}</small>
          </td>
          <td>
            <span v-show="!fra.iserror" class="tag is-primary">Ok</span>
            <span v-show="fra.iserror" class="tag is-danger">Error</span>
          </td>
          <td>
            <small v-if="fra.consultado">{{
              fra.response.statusDescription
            }}</small>
            <small v-if="!fra.consultado">{{
              fra.iserror
                ? "Documento con error"
                : "Documento enviado con éxito"
            }}</small>
            <small v-if="fra.consultado">
              <span v-show="viewDetalle(index)">
                <br />
                <span>{{ fra.response.statusMessage }}</span>
                <span v-if="fra.response.errorMessage"
                  ><br />
                  <span
                    class="fontMono"
                    v-for="(det, ind) in fra.response.errorMessage"
                    :key="ind"
                    >{{ det }} <br />
                  </span>
                </span>
              </span>
            </small>
          </td>
          <td>
            <button class="button is-small is-light" @click="detalle(fra)">
              <span class="icon is-small">
                <span class="material-icons"> cached </span>
              </span>
            </button>
            <button
              v-if="fra.consultado"
              class="button is-small is-info"
              @click="vDetalle(index)"
            >
              <span class="icon is-small">
                <span class="material-icons"> remove_red_eye </span>
              </span>
            </button>
            <router-link
              v-if="!fra.iserror"
              :to="{ name: 'reports.repgrafica', params: { id: fra._id } }"
              class="button is-small is-link"
            >
              <span class="icon is-small">
                <span>Ver</span>
              </span>
            </router-link>
            <button
              v-show="fra.iserror"
              class="button is-warning is-small"
              @click="reenviar(fra)"
            >
              Reenviar
            </button>
            <button class="button is-dark is-small" @click="downPDF(fra._id)">
              <span class="icon is-small">
                <span>PDF</span>
              </span>
            </button>
            <button
              v-if="fra.consultado"
              class="button is-primary is-small"
              @click="sendEmail(fra._id)"
            >
              <span class="icon is-small">
                <span class="material-icons"> email </span>
              </span>
            </button>
            <button
              v-if="fra.consultado"
              class="button is-link is-small"
              @click="sendEmail2(fra._id)"
            >
              <span class="icon is-small">
                <span class="material-icons"> forward_to_inbox </span>
              </span>
            </button>

            <span
              v-show="fra.sendemail"
              class="material-icons has-text-grey fuente"
            >
              forward_to_inbox
            </span>
            <span
              v-show="fra.refuse"
              class="material-icons has-text-danger fuente"
            >
              cancel
            </span>
            <span
              v-show="fra.agree"
              class="material-icons has-text-success fuente"
            >
              check_circle
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <nav class="pagination" role="navigation" aria-label="pagination">
      <a class="pagination-previous" @click="previous">Anterior</a>
      <a class="pagination-previous">{{ pagination.inicial + 1 }}</a>
      <a class="pagination-next" @click="next">Siguiente</a>
      <ul class="pagination-list">
        <li>
          <a
            class="pagination-link"
            :class="pagination.inicial === 0 ? 'is-current' : ''"
            aria-label="Page 1"
            aria-current="page"
            @click="ir(0)"
            >1</a
          >
        </li>
        <li v-show="pagination.total > 1">
          <a
            class="pagination-link"
            :class="pagination.inicial === 1 ? 'is-current' : ''"
            aria-label="Goto page 2"
            @click="ir(1)"
            >2</a
          >
        </li>
        <li v-show="pagination.total > 2">
          <a
            class="pagination-link"
            :class="pagination.inicial === 2 ? 'is-current' : ''"
            aria-label="Goto page 3"
            @click="ir(2)"
            >3</a
          >
        </li>
        <li>
          <span class="pagination-ellipsis">&hellip;</span>
        </li>
        <li v-show="pagination.total > 5">
          <a
            class="pagination-link"
            :class="
              pagination.inicial === pagination.mitad - 1 ? 'is-current' : ''
            "
            @click="ir(pagination.mitad - 1)"
            >{{ pagination.mitad }}</a
          >
        </li>
        <li>
          <span class="pagination-ellipsis">&hellip;</span>
        </li>
        <li v-show="pagination.total > 4">
          <a
            class="pagination-link"
            :class="
              pagination.inicial === pagination.total - 1 ? 'is-current' : ''
            "
            aria-label="Goto page 47"
            @click="ir(pagination.total - 1)"
            >{{ pagination.total }}</a
          >
        </li>
      </ul>
    </nav>
    <div class="modal" :class="{ 'is-active': showmodal }">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Reenvío de la factura electrónica</p>
          <button
            class="delete"
            aria-label="close"
            @click="closemodal"
          ></button>
        </header>
        <section class="modal-card-body">
          <div class="field">
            <label class="label">Correo</label>
            <div class="control">
              <input
                v-model="dataemail.email"
                class="input"
                type="email"
                placeholder="Correo"
              />
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-success" @click="resendEmail">Enviar</button>
          <button class="button" @click="closemodal">Cancelar</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import yPeriodselector from "@/components/commons/PeriodselectorV2.vue";
import apiServices from "@/services/yungol-services";
import apiServicesDos from "@/services/yungol-servicesdos";

import { mapState } from "vuex";
export default {
  data() {
    return {
      showmodal: false,
      period: {
        year: null,
        months: null,
      },
      fras: [],
      pagination: {
        count: 0,
        inicial: 0,
        total: 0,
        mitad: 0,
      },
      vdet: null,
      dataemail: {
        name: null,
        email: null,
        _id: null,
      },
    };
  },
  computed: {
    ...mapState(["empresa"]),
  },
  methods: {
    closemodal() {
      this.dataemail = {
        name: null,
        email: null,
        _id: null,
      };
      this.showmodal = false;
    },
    sendEmail2(fraid) {
      this.dataemail._id = fraid;
      this.showmodal = true;
    },
    async downPDF(fraid) {
      try {
        if (fraid) {
          let result = await apiServicesDos.get(`/downfrapdf/${fraid}`, {
            responseType: "blob",
          });
          const url = window.URL.createObjectURL(
            new Blob([result.data], { type: "application/pdf" })
          );
          const link = document.createElement("a");
          link.href = url;
          let ahora = new Date();
          ahora = ahora.toISOString();
          link.setAttribute(`download`, `Archivo-${ahora}.pdf`); // or any other extension
          document.body.appendChild(link);
          console.log("el link es", link);
          link.click();
        }
      } catch (err) {
        console.log(err);
      }
    },
    async sendEmail(fraid) {
      try {
        if (fraid) {
          await apiServicesDos.get(`/sendemailfraelect/${fraid}`);
          this.$store.dispatch("notify", {
            message: `Correo enviado`,
            type: "is-primary",
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    async resendEmail() {
      try {
        if (!this.dataemail.email) {
          this.$store.dispatch("notify", {
            message:
              "Debe indicar el correo electrónico al que se le enviara la copia del documento.",
            type: "is-danger",
            position: "top-center",
          });
          return false;
        }
        await apiServicesDos.post(`/resendemailfraelect`, this.dataemail);
        this.$store.dispatch("notify", {
          message: `Correo enviado`,
          type: "is-primary",
        });
        this.$store.dispatch("notify", {
          message: "Correo enviado",
          position: "top-center",
        });
        this.closemodal();
      } catch (err) {
        console.log(err);
      }
    },
    async reenviar(item) {
      try {
        const data = {
          fraelectid: item._id,
          year: item.year,
          mes: item.mes,
          comprobanteid: item.comprobanteid._id,
          documento: item.documento,
        };
        await apiServices.post(`/reenviaelectronica`, data);
        this.searchFras();
      } catch (err) {
        console.log(err);
      }
    },
    async detalle(fra) {
      const data = {
        id: fra._id,
        documento: fra.documento,
        prefijo: fra.comprobanteid.prefijo,
        idcomprobante: fra.comprobanteid._id,
        tipo: fra.tipo,
      };
      await apiServices.post(`/consultdocument`, data);
      this.searchFras();
    },
    vDetalle(index) {
      if (this.vdet === index) {
        this.vdet = null;
      } else {
        this.vdet = index;
      }
    },
    viewDetalle(index) {
      if (this.vdet === index) {
        return true;
      } else {
        return false;
      }
    },
    next() {
      if (this.pagination.inicial + 1 < this.pagination.total) {
        this.pagination.inicial++;
        this.searchFras();
      }
    },
    previous() {
      if (this.pagination.inicial > 0) {
        this.pagination.inicial--;
        this.searchFras();
      }
    },
    ir(n) {
      this.pagination.inicial = n;
      this.searchFras();
    },
    periodselected(period) {
      this.period = period;
      this.searchFras();
    },
    async searchFras() {
      try {
        const _this = this;
        const f = {
          inicial: _this.pagination.inicial * 20,
          year: _this.period.year,
          months: _this.period.months,
        };
        const result = await apiServices.post(`/searchfraelect`, f);
        if (result.data) {
          this.fras = result.data.data.map(function (k) {
            if (!k.response) {
              k.response = {
                message: {
                  errorMessage: "N/P",
                },
                data: {
                  statusDescription: "N/P",
                },
              };
              k.detalle = ["N/P"];
            } else {
              if (k.response.message) {
                if (Array.isArray(k.response.message.errorReason)) {
                  k.detalle = k.response.message.errorReason;
                } else {
                  k.detalle = [k.response.message.errorReason];
                }
              } else if (k.response.data) {
                if (Array.isArray(k.response.data.warnings)) {
                  k.detalle = k.response.data.warnings;
                } else {
                  k.detalle = [k.response.data.warnings];
                }
              } else {
                k.detalle = ["N/P"];
              }
            }
            return k;
          });

          _this.pagination.count = result.data.count;
          _this.pagination.total = Math.ceil(_this.pagination.count / 20);
          _this.pagination.mitad = Math.round(
            (_this.pagination.total - 3) / 2 + 3
          );
          if (_this.fras.length === 0) {
            _this.pagination.inicial = 0;
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  created() {
    const today = new Date();
    this.period.year = today.getFullYear();
    this.period.months = [today.getMonth() + 1];
    this.searchFras();
  },
  components: {
    yPeriodselector,
  },
};
</script>

<style lang="scss" scoped>
.fuente {
  font-size: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/reports/fraelectronica/Fraelectronicalist.vue